import { useTranslations } from "next-intl";
import Link from "@components/core/Link";
import { useCurrentUser, useSubscriptionStatus } from "@hooks/use-current-user";
import { subscriptionStatuses } from "@utils/constants/subscriptionStatuses";

const WarningRibbon = () => {
  const t = useTranslations("common");

  const user = useCurrentUser();
  const subscriptionStatus = useSubscriptionStatus();

  const paymentMethodHasMandate = ["paypal", "sepa_debit"].includes(
    user?.default_payment_method?.type,
  );
  const paymentMethodValid = user?.default_payment_method?.valid;

  const warningText = () => {
    switch (subscriptionStatus) {
      case subscriptionStatuses.pastDueWaitingForPause:
        return t("navbar.failed_invoices_warning.past_due_waiting_for_pause");
      case subscriptionStatuses.pastDueWaitingForCancelation:
        return t("navbar.failed_invoices_warning.past_due_waiting_for_cancelation");
      case subscriptionStatuses.pastDue:
        return t("navbar.failed_invoices_warning.past_due");
      default:
        if (!paymentMethodValid) {
          if (paymentMethodHasMandate) return t("navbar.invalid_warning");

          return t("navbar.credit_card_warning");
        }

        return "";
    }
  };

  if (!user || user.state === "lead") return null;
  if (["trialing", "active"].includes(user.subscription?.state) && paymentMethodValid) return null;

  if (["past_due"].includes(user.subscription?.state) || !paymentMethodValid) {
    return (
      <div
        className="bg-secondary d-flex justify-content-center align-items-center text-center position-relative px-4 py-2"
        style={{ minHeight: "2.5rem" }}
      >
        <Link
          className="mb-0 text-dark font-weight-normal line-height-sm"
          href={{
            pathname: "/profile/payment-method",
            query: {
              redirect: "/home",
            },
          }}
        >
          {warningText()}
        </Link>
      </div>
    );
  }

  return null;
};

export default WarningRibbon;
